import React, { useState, useEffect } from "react";
import Title from "../title/title";
import Tag from "../tag/tag";
import Field from "../field/field";
import DropDownMenu from "../dropDownMenu/dropDownMenu";
import FaSpinner from "../faSpinner/faSpinner";
import { categoriesParser } from "../../constants/parse/product";
import useToken from "../../customHooks/useToken";
import useUserId from "../../customHooks/useUserId";
import APIProductService from "../../services/APIProductService";

const ProductCategoriesFilter = ({ selectApiProductCategory }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const csrfToken = useToken();
  const userId = useUserId();

  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      setError(null);
      try {
        const rawCategories = await APIProductService.getCategoryList(
          userId,
          csrfToken
        );
        // Parse categories in the component (UI concern)
        const parsedCategories = categoriesParser(rawCategories);
        setCategories(parsedCategories);
      } catch (err) {
        console.error("Error loading categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, [userId]); // Reload if the user changes (login/logout)

  if (loading) {
    return <FaSpinner loading />;
  }

  if (error) {
    return <div>Error loading categories</div>;
  }

  return (
    <>
      <Title type="small">
        <Tag>FILTER APIs</Tag>
      </Title>

      <Field className="side">
        <DropDownMenu
          items={categories.map((item) => ({
            name: item.name,
            value: item.uuid,
          }))}
          name="ALL CATEGORIES"
          selectHandler={selectApiProductCategory}
        />
      </Field>
    </>
  );
};

export default ProductCategoriesFilter;
